import { Link } from 'react-router-dom';

export default function MobileCtaBar() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="bg-white border-t border-gray-200 px-3 pt-2.5 pb-2.5 flex gap-2">
        <a
          href="tel:+4921027398070"
          className="flex-1 flex items-center justify-center gap-2 bg-[#0D2B4E] text-white py-3.5 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer active:opacity-80 transition-opacity"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-phone-fill text-lg" />
          </div>
          <span>Anrufen</span>
        </a>
        <Link
          to="/kontakt"
          className="flex-1 flex items-center justify-center gap-2 bg-[#C8A96E] text-white py-3.5 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer active:opacity-80 transition-opacity"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-mail-send-line text-lg" />
          </div>
          <span>Angebot anfragen</span>
        </Link>
      </div>
    </div>
  );
}
